import { render } from "./Credit.vue?vue&type=template&id=a7eb3bfe&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"

import "./Credit.vue?vue&type=style&index=0&id=a7eb3bfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7eb3bfe"]])

export default __exports__